import mitt from 'mitt';
const emitter = mitt();

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('bus', {
    $emit: emitter.emit,
    $on: emitter.on,
  });
});
